import { useContext } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ChatUserContext } from '../../../core/chatContext';

import styles from './newChat.module.scss';

import DriveRenameIcon from '@mui/icons-material/DriveFileRenameOutline';
import { MenuContext } from '../../../context/menuContext';
import toast from 'react-hot-toast';


const NewChatComponent: React.FC = () => {
    const currChatContext: any = useContext(ChatUserContext);
    const { toggleMenu, isMenuOpen } = useContext(MenuContext);

    const newConversation = () => {
        currChatContext.setCurrChat((prevCurrChat: any) => {
            prevCurrChat.messages = [];
            prevCurrChat['data_sources'][0]['parameters']['new_document'] = false;
            prevCurrChat['data_sources'][0]['parameters']['conversationId'] = crypto.randomUUID();
            prevCurrChat.data_sources[0].parameters.vector_store_id = null;
            prevCurrChat.data_sources[0].parameters.thread_id = null;
            return prevCurrChat;
        });

        currChatContext.setUserAsks([]);
        currChatContext.setIaAnswers([]);
        currChatContext.setFilesSelected([]);
    }

    return (
        <Tooltip placement="right" arrow title="Nueva conversación">
            <div className={styles.newChatComponent} onClick={() => {
                if (currChatContext.isLoading || currChatContext.isUploading) { 
                    toast.error("Espere a que termine el proceso en curso.", { duration: 2000 });
                    return; 
                }
                
                newConversation();
                isMenuOpen && window.innerWidth < 1025 && toggleMenu();
            }} role="button">
                <span>
                    <DriveRenameIcon />
                </span>
            </div>
        </Tooltip>
    )
}

export { NewChatComponent }


